import { render, staticRenderFns } from "./rejectImmPass.vue?vue&type=template&id=b5c0d94e&"
import script from "./rejectImmPass.vue?vue&type=script&lang=js&"
export * from "./rejectImmPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports